import { ResultSet } from "@cubejs-client/core";

import { AppThunk } from "appThunk";
import { Store } from "modules/customer/insights/portfolioNew/store";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

export class FootfallCentile {
    public readonly retailCentreId: number;
    public readonly centile: number;

    constructor(
        retailCentreId: number,
        centile: number,
    ) {
        this.retailCentreId = retailCentreId;
        this.centile = centile;
    }
}

export const loadFootfallCentiles = (stores: Store[]): AppThunk<Promise<FootfallCentile[]>> => async (dispatch) => {
    try {
        const retailCentreIds = stores.map(store => store.retailCentreID.toString());
        const query = {
            dimensions: [
                "LocationBenchmarkStaticMetrics.RetailCentreID",
                "LocationBenchmarkStaticMetrics.FootfallCountCentile"
            ],
            filters: [{
                member: "LocationBenchmarkStaticMetrics.RetailCentreID",
                operator: "equals",
                values: retailCentreIds
            }]
        };
        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        return resultSet.rawData().map(row => {
            return new FootfallCentile(
                Number(row["LocationBenchmarkStaticMetrics.RetailCentreID"]),
                Number(row["LocationBenchmarkStaticMetrics.FootfallCountCentile"]) || 0,
            );
        });
    } catch (error) {
        dispatch(logError("Error loading FootfallCentile.", error));
        throw error;
    }
};
